// extracted by mini-css-extract-plugin
module.exports = {"root":"Header__root--XychT","center":"Header__center--1VfBa","left":"Header__left--3lTCK","right":"Header__right--2qWZk","spacer":"Header__spacer--1EuLr"};